exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse[data-v-c9ad6d2a] .ant-collapse {\n  border: 1px solid #eef7ff;\n}\n", ""]);

// exports
